import { render, staticRenderFns } from "./vsListItem.vue?vue&type=template&id=a87abea8&lang=html&"
import script from "./vsListItem.vue?vue&type=script&lang=js&"
export * from "./vsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsListItem.vue"
export default component.exports